import InfographicImg from "public/cloudSecuritySase/infographic.png";

export const DESC_CONSTANTS = {
  title: "Vulnerability & Patch Management — Unified by OneMind  ",
  list: [
    {
      label: "Continuous Vulnerability Scanning ",
      subLabel: "Proactively find risks before attackers do ",
      subText:
        "Powered by Tenable, OneMind scans for unpatched software, misconfigurations, and exposed assets across your cloud, on-prem, and edge environments. ",
      points: [
        "AI-driven scanning for known CVEs and misconfigurations ",
        "Real-time intel feeds to surface emerging threats ",
        "Full-stack visibility — servers, endpoints, workloads, IoT ",
      ],
    },
    {
      label: "Automated Patch Management",
      subLabel: "Apply critical updates without disrupting operations",
      subText:
        "Through tight integrations with Red Hat, OneMind automates patching across complex IT stacks.",
      points: [
        "Zero-touch patching across Linux, Windows & 3rd-party apps",
        "Rollback/failover to ensure service continuity",
        "Schedule-based or policy-triggered patch deployment",
      ],
    },
    {
      label: "AI-Based Risk Prioritization",
      subLabel: "Fix what matters most — first",
      subText:
        "OneMind’s platform ranks vulnerabilities by real-world exploitability and business impact, helping teams reduce risk fast.",
      points: [
        "Severity + exploitability scoring from live threat data",
        "Risk-based patch sequencing to maximize security ROI",
        "Audit-ready reporting to meet SOC 2, PCI-DSS, NIST",
      ],
    },
    {
      label: "Powered by Our Ecosystem of Experts",
      subText: "OneMind integrates with industry leaders to deliver defense-in-depth: ",
      points: [
        "Tenable → Global vulnerability & threat intelligence",
        "Red Hat → Enterprise-grade patch automation",
      ],
    },
  ],
  noteText: {
    label: "NOTE",
    text: "All actions are orchestrated via the OneMind platform, unifying detection, response, and compliance in one intelligent workflow.",
  },
  image: InfographicImg,
  maxW: "600px",
};
